import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SystemValidationTextField } from "../../../components/UIToolkit/Inputs/SystemValidationTextField";
import { SystemBanner } from "../../../components/UIToolkit/molecules/SystemBanner";
import SystemButton from "../../../components/UIToolkit/SystemButton/SystemButton";
import { SECTION_HEADER_KEY, SECTION_ORDER, type useAutoPromptSection } from "./useAutoPromptSection";

type Props = { state: ReturnType<typeof useAutoPromptSection> };

export function AutoPromptAnalysisPanel({ state }: Props) {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }} data-testid="auto-prompt-analysis">
			{state.flags.length > 0 && (
				<SystemBanner
					tone="warning"
					title={t("onboarding_auto_prompt.attention_title")}
					descriptionComponent="div"
					description={
						<Box component="ul" sx={{ pl: 2.5, my: 0 }}>
							{state.flags.map((flag) => (
								<li key={flag}>{flag}</li>
							))}
						</Box>
					}
					dataTestId="auto-prompt-analysis-flags"
				/>
			)}

			{SECTION_ORDER.map((key) => (
				<Paper key={key} variant="outlined" sx={{ p: 2 }}>
					<Typography variant="overline" sx={{ display: "block", mb: 1, color: "text.secondary" }}>
						{t(SECTION_HEADER_KEY[key])}
					</Typography>
					<SystemValidationTextField
						fullWidth
						value={state.editable?.[key]}
						onChange={(event) => state.setEditable((previous) => (previous ? { ...previous, [key]: event.target.value } : previous))}
						injectedProps={{ multiline: true, minRows: 3 }}
						dataTestId={`auto-prompt-section-${key.replaceAll("_", "-")}`}
					/>
				</Paper>
			))}

			<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
				<SystemButton onClick={state.handleGeneratePrompt} data-testid="auto-prompt-generate-prompt-button">
					{t("onboarding_auto_prompt.generate_prompt")}
				</SystemButton>
			</Box>
		</Box>
	);
}
